import classNames from 'classnames';
import { memo } from 'react';

import { ArrowLeftIcon, ArrowRightIcon } from '@air/design-icons';
import { ButtonGroup } from '@air/primitive-button-group';
import { IconButton } from '@air/primitive-icon-button';

import {
  ASSET_MODAL_NEXT,
  ASSET_MODAL_NEXT_DISABLED,
  ASSET_MODAL_PREVIOUS,
  ASSET_MODAL_PREVIOUS_DISABLED,
} from '~/constants/testIDs';

export type PreviousAndNextNavigationArrowsProps = {
  onPreviousClick?: () => void;
  onNextClick?: () => void;
  className?: string;
};

export const PreviousAndNextNavigationArrows = memo(
  ({ onPreviousClick, onNextClick, className }: PreviousAndNextNavigationArrowsProps) => {
    const hasPrevious = !!onPreviousClick;
    const hasNext = !!onNextClick;

    return (
      <ButtonGroup className={classNames('flex items-center', className)}>
        <IconButton
          adsIcon
          color="gray"
          icon={ArrowLeftIcon}
          label="Previous asset"
          onClick={onPreviousClick}
          disabled={!hasPrevious}
          data-testid={hasPrevious ? ASSET_MODAL_PREVIOUS : ASSET_MODAL_PREVIOUS_DISABLED}
          size="medium"
        />
        <IconButton
          adsIcon
          color="gray"
          icon={ArrowRightIcon}
          label="Next asset"
          onClick={onNextClick}
          disabled={!hasNext}
          data-testid={hasNext ? ASSET_MODAL_NEXT : ASSET_MODAL_NEXT_DISABLED}
          size="medium"
        />
      </ButtonGroup>
    );
  },
);

PreviousAndNextNavigationArrows.displayName = 'PreviousAndNextNavigationArrows';
